import React, { useState, useEffect } from "react";
import { IconBellRinging, IconSearch, IconFilter, IconRefresh, IconChevronUp, IconChevronDown, IconSettings, IconCirclePlus, IconPencil, IconTrash, IconX } from "@tabler/icons-react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/images/paqtory.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchShipments } from "../../redux/slices/shippingSlice";
import Sidebar from "../../components/common/AdminSideBar";
import LoadingFallback from "../../components/common/LoadingFallback";
import ErrorFallback from "../../components/common/ErrorFallback";
function NavItem({ label, to }) {
  const location = useLocation();
  const isActive = location.pathname === to;
  return (
    <Link
      to={to}
      className={`px-3 py-2 rounded-md cursor-pointer flex items-center gap-2 ${isActive ? "bg-[#FFD500] text-[#0B0C52] font-semibold" : "hover:bg-white/10 text-white"
        }`}
    >
      {label}
    </Link>
  );
}

function IconButton({ children, onClick }) {
  return (
    <button onClick={onClick} className="p-1 hover:bg-gray-100 rounded transition">
      {children}
    </button>
  );
}

function ShippingDelivery() {
  const dispatch = useDispatch();
  // const { loading, error, data: allShipments } = useSelector((state) => state.shipping);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [allShipments, setAllShipments] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [modalType, setModalType] = useState(null);
  const [selectedShipment, setSelectedShipment] = useState(null);
  const pageSize = 10;

  useEffect(() => {
    dispatch(fetchShipments());
  }, [dispatch]);

  const filteredShipments = allShipments.filter((ship) => {
    const inOrderId = ship.orderId?.toLowerCase().includes(searchTerm.toLowerCase());
    const inTracking = ship.trackingNumber?.toLowerCase().includes(searchTerm.toLowerCase());
    return inOrderId || inTracking;
  });

  const totalCount = filteredShipments.length;
  const totalPages = Math.ceil(totalCount / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentShipments = filteredShipments.slice(startIndex, endIndex);
  const fromCount = startIndex + 1;
  const toCount = endIndex > totalCount ? totalCount : endIndex;

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };
  function openModal(type, ship = null) {
    setSelectedShipment(ship);
    setModalType(type);
  }
  function closeModal() {
    setSelectedShipment(null);
    setModalType(null);
  }

  if (loading) {
    return <LoadingFallback />
  }
  if (error) {
    return <ErrorFallback error={error} onRetry={() => dispatch(fetchShipments())} />
  }

  return (
    <div className="min-h-screen flex bg-[#F9F9FF] text-gray-800">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <header className="h-16 bg-white flex items-center justify-between px-6 shadow-sm">
          <h2 className="text-xl font-semibold text-[#0B0C52]">Shipping & Delivery</h2>
          <div className="flex items-center gap-4">
            <button className="border border-gray-300 text-sm rounded px-3 py-1 hover:bg-gray-100">
              Eng
              <span className="ml-2">&#x25BE;</span>
            </button>
            <button className="text-gray-500 hover:text-gray-700">
              <IconBellRinging size={24} />
            </button>
            <div className="w-8 h-8 rounded-full bg-gray-300 overflow-hidden" />
          </div>
        </header>
        <main className="p-6 flex-1 overflow-y-auto">
          <div className="border-2 border-[#463BC9] rounded-md bg-[#F9F9FF] p-4">
            <div className="flex flex-wrap items-center gap-2 mb-4">
              <select className="border border-gray-300 rounded text-sm px-2 py-1 focus:outline-none focus:ring-1 focus:ring-[#0B0C52]">
                <option>Bulk Action</option>
                <option>Delete Selected</option>
                <option>Mark Shipped</option>
                <option>Mark Delivered</option>
              </select>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search by Order ID, Tracking Number"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="border border-gray-300 rounded text-sm px-3 py-1 pr-8 focus:outline-none focus:ring-1 focus:ring-[#0B0C52]"
                />
                <IconSearch size={16} className="absolute right-2 top-2 text-gray-400" />
              </div>
              <span className="text-sm text-gray-700 ml-auto mr-1">
                {fromCount} - {toCount} of {totalCount}
              </span>
              <button onClick={handlePrevPage} className="p-1 hover:bg-gray-100 rounded">
                <IconChevronUp size={18} />
              </button>
              <button onClick={handleNextPage} className="p-1 hover:bg-gray-100 rounded">
                <IconChevronDown size={18} />
              </button>
              <IconButton onClick={() => openModal("FILTER")}>
                <IconFilter size={18} />
              </IconButton>
              <IconButton>
                <IconRefresh size={18} />
              </IconButton>
              <IconButton>
                <IconSettings size={18} />
              </IconButton>
              <button
                className="bg-green-500 text-white text-sm px-3 py-1 rounded hover:bg-green-600 flex items-center gap-1"
                onClick={() => openModal("ADD")}
              >
                <IconCirclePlus size={18} />
                Add New Template
              </button>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b-2 border-[#463BC9] bg-[#F9F9FF] text-[#120E43]">
                    <th className="px-4 py-2 w-10">
                      <input type="checkbox" />
                    </th>
                    <th className="px-4 py-2 text-left">Order ID</th>
                    <th className="px-4 py-2 text-left">Shipping Carrier</th>
                    <th className="px-4 py-2 text-left">Date</th>
                    <th className="px-4 py-2 text-left">Tracking Number</th>
                    <th className="px-4 py-2 text-left">Delivery Status</th>
                    <th className="px-4 py-2 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentShipments.map((ship) => (
                    <tr key={ship.id} className="border-b border-gray-200 hover:bg-gray-50">
                      <td className="px-4 py-2">
                        <input type="checkbox" />
                      </td>
                      <td className="px-4 py-2">{ship.orderId}</td>
                      <td className="px-4 py-2">{ship.carrier}</td>
                      <td className="px-4 py-2">{ship.date}</td>
                      <td className="px-4 py-2">{ship.trackingNumber}</td>
                      <td className="px-4 py-2">{ship.status}</td>
                      <td className="px-4 py-2">
                        <div className="flex items-center gap-2">
                          <button className="text-blue-600 hover:text-blue-800 flex items-center gap-1" onClick={() => openModal("EDIT", ship)}>
                            <IconPencil size={16} />
                            Edit
                          </button>
                          <button className="text-red-500 hover:text-red-700 flex items-center gap-1" onClick={() => openModal("DELETE", ship)}>
                            <IconTrash size={16} />
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {currentShipments.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center py-4 text-gray-500">
                        No shipments found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="mt-2 flex flex-col sm:flex-row items-start sm:items-center justify-between text-sm text-gray-600">
              <div />
              <div className="mt-2 sm:mt-0 space-x-4">
                <span className="text-[#0B0C52]">
                  Total Shipments: <strong>{allShipments.length}</strong>
                </span>
              </div>
            </div>
          </div>
        </main>
      </div>
      {modalType === "FILTER" && <FilterModal onClose={closeModal} />}
      {modalType === "ADD" && <AddShippingModal onClose={closeModal} />}
      {modalType === "EDIT" && selectedShipment && <EditShippingModal shipment={selectedShipment} onClose={closeModal} />}
      {modalType === "DELETE" && selectedShipment && <DeleteShippingModal shipment={selectedShipment} onClose={closeModal} />}
    </div>
  );
}

export default ShippingDelivery;

function FilterModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white w-[600px] max-w-full rounded-md p-6 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-700">
          <IconX size={20} />
        </button>
        <h2 className="text-lg font-semibold mb-4">Filter Shipments</h2>
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-semibold mb-1">Delivery Status</label>
            <select className="border border-gray-300 rounded w-full px-2 py-1">
              <option>All</option>
              <option>Processing</option>
              <option>Shipped</option>
              <option>Delivered</option>
              <option>Returned</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Shipping Carrier</label>
            <select className="border border-gray-300 rounded w-full px-2 py-1">
              <option>All</option>
              <option>FedEx</option>
              <option>UPS</option>
              <option>DHL</option>
              <option>USPS</option>
            </select>
          </div>
        </div>
        <div className="flex gap-2 justify-end">
          <button onClick={onClose} className="bg-[#0B0C52] text-white px-4 py-2 rounded hover:opacity-90">
            Apply
          </button>
          <button onClick={onClose} className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:opacity-80">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

function AddShippingModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white w-[600px] max-w-full rounded-md p-6 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-700">
          <IconX size={20} />
        </button>
        <h2 className="text-lg font-semibold text-[#0B0C52] mb-4">Add New Template</h2>
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-semibold mb-1">Order ID</label>
            <input type="text" placeholder="#ORD1001" className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Shipping Carrier</label>
            <select className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]">
              <option>FedEx</option>
              <option>UPS</option>
              <option>DHL</option>
              <option>USPS</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Date</label>
            <input type="date" className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Tracking Number</label>
            <input type="text" placeholder="1234567890" className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Delivery Status</label>
            <select className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]">
              <option>Processing</option>
              <option>Shipped</option>
              <option>Delivered</option>
              <option>Returned</option>
            </select>
          </div>
        </div>
        <div className="flex gap-4">
          <button onClick={onClose} className="bg-[#0B0C52] text-white px-4 py-2 rounded hover:opacity-90">
            Save
          </button>
          <button onClick={onClose} className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:opacity-80">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

function EditShippingModal({ shipment, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white w-[600px] max-w-full rounded-md p-6 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-700">
          <IconX size={20} />
        </button>
        <h2 className="text-lg font-semibold text-[#0B0C52] mb-4">Edit Shipping</h2>
        <p className="text-sm text-gray-600 mb-4">
          Editing shipment: <strong>{shipment.orderId}</strong>
        </p>
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-semibold mb-1">Order ID</label>
            <input type="text" defaultValue={shipment.orderId} className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Shipping Carrier</label>
            <select defaultValue={shipment.carrier} className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]">
              <option>FedEx</option>
              <option>UPS</option>
              <option>DHL</option>
              <option>USPS</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Date</label>
            <input type="date" className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Tracking Number</label>
            <input type="text" defaultValue={shipment.trackingNumber} className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">Delivery Status</label>
            <select defaultValue={shipment.status} className="border-2 border-[#463BC9] w-full rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#463BC9]">
              <option>Processing</option>
              <option>Shipped</option>
              <option>Delivered</option>
              <option>Returned</option>
            </select>
          </div>
        </div>
        <div className="flex gap-4">
          <button onClick={onClose} className="bg-[#0B0C52] text-white px-4 py-2 rounded hover:opacity-90">
            Update
          </button>
          <button onClick={onClose} className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:opacity-80">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

function DeleteShippingModal({ shipment, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white w-[500px] max-w-full rounded-md p-6 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-700">
          <IconX size={20} />
        </button>
        <h2 className="text-lg font-semibold text-red-600 mb-4 flex items-center gap-2">
          <IconTrash size={20} />
          Delete Shipping
        </h2>
        <p className="text-sm text-gray-600 mb-4">
          Are you sure you want to permanently delete <strong>{shipment.orderId}</strong>?
        </p>
        <div className="flex gap-4">
          <button onClick={onClose} className="bg-red-500 text-white px-4 py-2 rounded hover:opacity-90">
            Delete
          </button>
          <button onClick={onClose} className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:opacity-80">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
